import React, { useState, Fragment, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FineInformation.module.scss'
import { fineNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const FineNumber = ({ t, validateFineNumber, fineNumberError, fineNumberValid, fineNumberJEINError, errMsg, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, setIsFocussed] = useState(false)

  const fineNumber = useSelector((state) => state.app.fineNumber)

  const handleFineNumber = (e) => {
    let number = e.currentTarget.value
    verifyFineNumber(number)
  }

  const onBlurFineNumber = (e) => {
    let number = e.currentTarget.value.trim()
    verifyFineNumber(number)
    setIsFocussed(false)
  }

  const verifyFineNumber = (number) => {
    try {
      dispatch(fineNumberAction(number))
      // validateFineNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const fineNumberLabel = (
    <label className="control-label" htmlFor="FineNumber">
      <b>{t('fine_information.fine_number')}</b>
    </label>
  )

  return (
    <div className={['form-group', styles['fields_margin']].join(' ')}>
      {errMsg || fineNumberValid === false ? (
        <div className={styles['error_div']}>
          <div className={styles['vertical_line']} style={{ height: errMsg ? '120px' : '95px' }}></div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {fineNumberLabel}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', marginBottom: '10px' }} className="has-error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" style={{ marginTop: '5px' }}></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>
                {fineNumberJEINError ? fineNumberJEINError : errMsg ? t(errMsg) : t(fineNumberError)}
              </div>
            </div>
            <input
              autoFocus
              type="text"
              id="FineNumber"
              style={{ border: '1px solid #d3423b', width: '100px' }}
              className={['ns-input form-control', 'has-error', styles['input_style']].join(' ')}
              value={fineNumber}
              onChange={handleFineNumber}
              onBlur={onBlurFineNumber}
              onFocus={() => setIsFocussed(true)}
              autoComplete="off"
              maxLength="10"
            />
          </div>
        </div>
      ) : (
        <Fragment>
          {fineNumberLabel}
          <input
            autoFocus
            type="text"
            id="FineNumber"
            className={['ns-input form-control', styles['field_width']].join(' ')}
            value={fineNumber}
            onChange={handleFineNumber}
            onBlur={onBlurFineNumber}
            onFocus={() => setIsFocussed(true)}
            autoComplete="off"
            maxLength="10"
          />
        </Fragment>
      )}
    </div>
  )
}

export default withTranslation('common')(FineNumber)
